/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TaskDto = {
    type?: TaskDto.type;
    count?: number;
};
export namespace TaskDto {
    export enum type {
        PRODUCT_RELEASE_ENGAGEMENT_ACTION_REQUIRED = 'PRODUCT_RELEASE_ENGAGEMENT_ACTION_REQUIRED',
        PRODUCT_INVOICE_ACTION_REQUIRED = 'PRODUCT_INVOICE_ACTION_REQUIRED',
        PRODUCT_FORMULATION_ANNUAL_REPORT_DUE = 'PRODUCT_FORMULATION_ANNUAL_REPORT_DUE',
        PRODUCT_FORMULATION_ANNUAL_REPORT_OVERDUE = 'PRODUCT_FORMULATION_ANNUAL_REPORT_OVERDUE',
        ANY_ACTION_REQUIRED = 'ANY_ACTION_REQUIRED',
        COMPANY_INVOICE_OPEN = 'COMPANY_INVOICE_OPEN',
        PRODUCT_CERTIFICATE_ACTION_REQUIRED = 'PRODUCT_CERTIFICATE_ACTION_REQUIRED',
        PRODUCT_APPROVAL_REWORK_NECESSARY = 'PRODUCT_APPROVAL_REWORK_NECESSARY',
        PRODUCT_APPROVAL_REJECTED = 'PRODUCT_APPROVAL_REJECTED',
    }
}

